import numeral from 'numeral';

import { DEFAULT_CURRENCY_FORMAT_PATTERN } from '../constants/currency';

export function sanitizeAmount(amount: string | number) {
    const match = amount
        .toString()
        .match(/(.+|)(\D)(\d{1,2}$)/);

    if (!match) {
        return amount;
    }

    const integerNumber = match[1].replace(/\D/, '');
    const decimalDelimiter = match[2];
    const decimalNumber = match[3];
    const replaceDecimalDelimiter = numeral.localeData()?.delimiters?.decimal;

    if (decimalDelimiter &&
        replaceDecimalDelimiter &&
        (decimalDelimiter === '.' || decimalDelimiter === ',')) {
        return `${integerNumber}${replaceDecimalDelimiter}${decimalNumber}`;
    }

    return amount;
}

export function formatCurrency(
    value: number | string,
    locale: string,
    format: string = DEFAULT_CURRENCY_FORMAT_PATTERN
) {
    if (!value) {
        return '';
    }

    if (locale) {
        numeral.locale(locale);
    }

    const amount = sanitizeAmount(value);

    return numeral(amount).format(format, Math.floor) || '';
}

// This function rounds based on the third decimal:
// if:      3rd decimal < 5 => round down
// else if: 3rd decimal >= 5 => round up
export function formatCurrencyRounded(
    value: number | string,
    locale: string,
    format: string = DEFAULT_CURRENCY_FORMAT_PATTERN
) {
    if (!value) {
        return '';
    }

    if (locale) {
        numeral.locale(locale);
    }

    const rawAmount = sanitizeAmount(value);

    // Convert locale decimal separator to '.' because Number() returns NaN for ','
    const localeDecimal = numeral.localeData()?.delimiters?.decimal || '.';
    let normalized = rawAmount.toString();

    if (localeDecimal !== '.') {
        normalized = normalized.replace(localeDecimal, '.');
    }

    const numericAmount = Number(normalized);

    if (!Number.isFinite(numericAmount)) {
        return '';
    }

    const roundedAmount = Math.round(Number(numericAmount) * 100) / 100;

    return numeral(roundedAmount).format(format) || '';
}
